<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento R1M (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoR1M" #txtRendimentoR1M formControlName="rendimento_r1m"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento C1M (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoC1M" #txtRendimentoC1M formControlName="rendimento_c1m"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento R2 (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoR2" #txtRendimentoR2 formControlName="rendimento_r2"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento C2 (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoC2" #txtRendimentoC2 formControlName="rendimento_c2"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento R3 (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoR3" #txtRendimentoR3 formControlName="rendimento_r3"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Rendimento C3 (%)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRendimentoC3" #txtRendimentoC3 formControlName="rendimento_c3"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín R1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinR1m" #txtMinR1m formControlName="min_r1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín C1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinC1m" #txtMinC1m formControlName="min_c1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín R2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinR2" #txtMinR2 formControlName="min_r2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín C2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinC2" #txtMinC2 formControlName="min_c2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín R3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinR3" #txtMinR3 formControlName="min_r3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Mín C3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMinC3" #txtMinC3 formControlName="min_c3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx R1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxR1M" #txtMaxR1M formControlName="max_r1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx C1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxC1M" #txtMaxC1M formControlName="max_c1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx R2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxR2" #txtMaxR2 formControlName="max_r2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx C2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxC2" #txtMaxC2 formControlName="max_c2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx R3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxR3" #txtMaxR3 formControlName="max_r3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Máx C3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtMaxC3" #txtMaxC3 formControlName="max_c3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range R1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeR1m" #txtRangeR1m formControlName="range_r1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range C1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeC1m" #txtRangeC1m formControlName="range_c1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range R2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeR2" #txtRangeR2 formControlName="range_r2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range C2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeC2" #txtRangeC2 formControlName="range_c2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range R3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeR3" #txtRangeR3 formControlName="range_r3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Range C3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtRangeC3" #txtRangeC3 formControlName="range_c3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV R1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevR1M" #txtSdevR1M formControlName="sdev_r1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV C1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevC1M" #txtSdevC1M formControlName="sdev_c1m" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV R2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevR2" #txtSdevR2 formControlName="sdev_r2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV C2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevC2" #txtSdeC2 formControlName="sdev_c2" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV R3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevR3" #txtSdevR1M formControlName="sdev_r3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">SDEV C3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSdevC3" #txtSdevC3 formControlName="sdev_c3" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado R1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoR1M" #txtResultadoR1M formControlName="resultado_r1m"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado C1M
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoC1M" #txtResultadoC1M formControlName="resultado_c1m"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado R2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoR2" #txtResultadoR2 formControlName="resultado_r2"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado C2
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoC2" #txtResultadoC2 formControlName="resultado_c2"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado R3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoR3" #txtResultadoR3 formControlName="resultado_r3"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado C3
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtResultadoC3" #txtResultadoC3 formControlName="resultado_c3"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>